import React from 'react';
import { FormControl, MenuItem, Box, Grid, TextField, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// Info tooltip text keyed by the data type that should display an info icon
const dataTypeInfoText = {
  searchVariants:
    'This tool will search the ED3N database for variants found in patients uploaded by any ED3N-participating program. Variants can be searched for by HGVS name, GRCh38 location, or a combination of variant properties.',
  searchGenotypes:
    "This tool will search your program's patient data for patients where one or more variants occurs. The patient biochemical and clinical data can be compared to search for commonalities between those patients."
};

const infoIconStyle = {
  fontSize: '1.1rem',
  color: 'var(--info-color)',
  cursor: 'pointer',
  pointerEvents: 'auto',
  verticalAlign: 'middle',
};

const SelectDataSettingsPanel = ({ classes, dataType, onChange, availableDataToView }) => {
  const infoText = dataTypeInfoText[dataType];

  return (
    <Grid container spacing={2} mb={2}>
      <Box component={Grid} item xs={12} sm={5}>
        <FormControl fullWidth sx={{ position: 'relative' }}>
          <TextField
            size="small"
            id="dataToView"
            className={classes.muiInputs}
            value={dataType}
            onChange={(e) => onChange(e.target.value)}
            variant="outlined"
            label="Select Data to View"
            select
            SelectProps={{
              MenuProps: { disableScrollLock: true, disablePortal: true }
            }}
          >
            {Array.isArray(availableDataToView) && availableDataToView.length > 0 ? (
              availableDataToView.map((data) => (
                <MenuItem key={data.dataTypeId} value={data.dataTypeId}>
                  {data.dataTypeName}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>No data available</MenuItem>
            )}
          </TextField>
          {/* Keyboard-accessible info icon overlaid before the dropdown arrow.
              Absolutely positioned so it does not shrink the clickable select area. */}
          {infoText && (
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                right: 32,
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Tooltip title={infoText} placement="top" arrow>
                <span
                  tabIndex={0}
                  role="img"
                  aria-label={infoText}
                  onMouseDown={(e) => e.stopPropagation()}
                  style={{ display: 'flex', alignItems: 'center', pointerEvents: 'auto' }}
                >
                  <InfoOutlinedIcon style={infoIconStyle} />
                </span>
              </Tooltip>
            </Box>
          )}
        </FormControl>
      </Box>
    </Grid>
  );
};

export default SelectDataSettingsPanel;
